import { postData } from "@componentAPIs";
import {
  logPhysicalDrFailure,
  PRINT_PHYSICAL_DR_FAILED_MESSAGE,
} from "../utils/physicalDrLogging";

interface GeneratePhysicalDrParams {
  terminalCode: string;
  routeIds: string[];
  signal?: AbortSignal;
}

const failGenerate = (context: string, response: unknown): never => {
  logPhysicalDrFailure(context, response);
  throw new Error(PRINT_PHYSICAL_DR_FAILED_MESSAGE);
};

export async function fetchPhysicalDrPdfUrl({
  terminalCode,
  routeIds,
  signal,
}: GeneratePhysicalDrParams): Promise<string> {
  const response = (await postData(
    "GeneratePhysicalDR",
    { terminalCode, routeIds },
    signal ? { signal } : {}
  )) as any;

  const status = response?.status ?? 0;
  if (!response || Math.trunc(status / 100) !== 2) {
    failGenerate("GeneratePhysicalDR API error", response);
  }

  const url = response?.data?.blobSasUrl;
  if (!url) {
    failGenerate("GeneratePhysicalDR missing blobSasUrl", response);
  }

  return url;
}
